import React from "react";
import { useTranslation } from "react-i18next";
import { Layout, Typography } from "antd";
import { Media } from "../AppMedia";
import MainHeader, {
  MENU_WOOD_IMPORT_SETTINGS_PRICE,
} from "../components/common/MainHeader";
import WoodImportSettingPriceList from "../components/wood-import/WoodImportSettingsPriceList";

export default function WoodImportSettingPriceListView() {
  const { Content } = Layout;
  const { Title } = Typography;
  const { t } = useTranslation();

  return (
    <div>
      <MainHeader activeItem={MENU_WOOD_IMPORT_SETTINGS_PRICE} />
      <Layout>
        <Content style={{ margin: "24px", marginTop: "7em" }}>
          <Title level={2}>
            {t("menus.wood_menus.wood_import_settings_price")}
          </Title>
          <Media greaterThanOrEqual="md">
            <WoodImportSettingPriceList />
          </Media>
        </Content>
      </Layout>
    </div>
  );
}
